// Central content & config for Fast Life Studio Agency

export const CONTACT = {
  whatsappNumber: "393881241561",
  phoneDisplay: "388 124 1561",
  email: "info.fastlife.studioagency@gmail.com",
  instagram: "https://instagram.com/fastlife_studioagency",
  instagramHandle: "fastlife_studioagency",
  facebook: "https://facebook.com/",
  tiktok: "https://tiktok.com/",
  addressLine: "Via Giuseppe Garibaldi 23",
  city: "Nocera Inferiore (SA)",
  founder: "Fernando Padovano",
};

export const whatsappLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    text ||
      "Ciao Fernando, ho visitato il sito di Fast Life Studio Agency e vorrei ricevere maggiori informazioni sui vostri servizi."
  )}`;

export const WA = {
  general:
    "Ciao Fernando, ho visitato il sito di Fast Life Studio Agency e vorrei ricevere maggiori informazioni sui vostri servizi.",
  fast8:
    "Ciao Fernando, sono interessato al piano Fast 8 da 499 € al mese e vorrei ricevere maggiori informazioni.",
  fast12:
    "Ciao Fernando, sono interessato al piano Fast 12 da 699 € al mese e vorrei ricevere maggiori informazioni.",
  fernando:
    "Ciao Fernando, ho visitato il sito di Fast Life Studio Agency e vorrei parlare direttamente con te della mia attività.",
};

export const MEDIA = {
  heroVideo:
    "https://player.vimeo.com/external/434045526.sd.mp4?s=c27ee425d809eeecf77977a421b936e7ef414777&profile_id=164&oauth2_token_id=57447761",
  heroFallback:
    "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  camera:
    "https://images.unsplash.com/photo-1612548403247-aa2873e9422d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  editing:
    "https://images.unsplash.com/photo-1650661926447-9efb2610f64c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  logo: "/logo.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Servizi", href: "#servizi" },
  { label: "Metodo", href: "#metodo" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Piani", href: "#piani" },
  { label: "Chi è Fernando", href: "#fernando" },
  { label: "FAQ", href: "#faq" },
  { label: "Contatti", href: "#contatti" },
];

export const SERVICES = [
  {
    n: "01",
    title: "Studiamo la tua attività",
    desc: "Analizziamo servizi, prodotti, pubblico, obiettivi e punti di forza.",
    icon: "Search",
  },
  {
    n: "02",
    title: "Creiamo idee e format",
    desc: "Sviluppiamo rubriche e contenuti adatti alla personalità dell'attività.",
    icon: "Lightbulb",
  },
  {
    n: "03",
    title: "Scriviamo gli script",
    desc: "Prepariamo testi semplici, naturali e facili da interpretare.",
    icon: "PenLine",
  },
  {
    n: "04",
    title: "Organizziamo lo shooting",
    desc: "Pianifichiamo le riprese per registrare più contenuti in maniera ordinata ed efficace.",
    icon: "CalendarClock",
  },
  {
    n: "05",
    title: "Registriamo e montiamo",
    desc: "Realizziamo riprese professionali, montaggio, sottotitoli, musiche e grafiche.",
    icon: "Clapperboard",
  },
  {
    n: "06",
    title: "Promuoviamo i contenuti",
    desc: "Una parte del prezzo mensile viene già destinata alle sponsorizzazioni.",
    icon: "Rocket",
  },
];

export const CONTENT_FORMATS = [
  "Video parlati",
  "Storytelling",
  "Presentazioni prodotto",
  "Tutorial",
  "Contenuti educativi",
  "Sketch",
  "Domande e risposte",
  "Trend adattati al brand",
  "Backstage",
  "Video promozionali",
  "Testimonianze",
  "Format seriali",
  "Contenuti emozionali",
  "Video dedicati ai servizi",
  "Video orientati alla vendita",
];

export const ADVANTAGES = [
  "Idee nuove ogni mese",
  "Script già preparati",
  "Guida durante le riprese",
  "Contenuti professionali",
  "Format personalizzati",
  "Riprese organizzate",
  "Montaggio completo",
  "Sottotitoli inclusi",
  "Strategia continuativa",
  "Sponsorizzazioni già comprese",
  "Prezzo finale chiaro",
  "Nessun costo nascosto",
  "Rapporto diretto con Fernando",
  "Contenuti per Instagram, Facebook e TikTok",
];

export const CLIENTS = [
  "Negozi",
  "Ristoranti",
  "Pizzerie",
  "Bar",
  "Locali",
  "Concessionarie",
  "Settore eventi",
  "Società di animazione",
  "Professionisti",
  "Centri estetici",
  "Centri benessere",
  "Strutture ricettive",
  "Aziende locali",
  "Brand",
  "Attività commerciali",
];

export const PLANS = [
  {
    id: "fast8",
    name: "Fast 8",
    oldPrice: "599",
    price: "499",
    videos: "8 video professionali al mese",
    adBudget: "49,90 €",
    recommended: false,
    waMessage:
      "Ciao Fernando, sono interessato al piano Fast 8 da 499 € al mese e vorrei ricevere maggiori informazioni.",
    tagline:
      "Il piano ideale per le attività che vogliono iniziare a comunicare con continuità e professionalità.",
    features: [
      "8 video professionali al mese",
      "Analisi dell'attività",
      "Studio del pubblico",
      "Strategia mensile",
      "Ideazione dei format e delle idee",
      "Scrittura degli script",
      "Organizzazione delle riprese",
      "Shooting professionale in 4K",
      "Luci e microfoni professionali",
      "Montaggio, sottotitoli, musiche e grafiche",
      "Ottimizzazione per Instagram, Facebook e TikTok",
      "Supporto continuativo",
      "Sponsorizzazioni mensili incluse",
    ],
  },
  {
    id: "fast12",
    name: "Fast 12",
    oldPrice: "799",
    price: "699",
    videos: "12 video professionali al mese",
    adBudget: "69,90 €",
    recommended: true,
    waMessage:
      "Ciao Fernando, sono interessato al piano Fast 12 da 699 € al mese e vorrei ricevere maggiori informazioni.",
    tagline:
      "Il piano pensato per le attività che vogliono una presenza social più frequente, più contenuti da testare e una maggiore varietà di format.",
    features: [
      "12 video professionali al mese",
      "Analisi dell'attività",
      "Studio approfondito del pubblico",
      "Strategia mensile completa",
      "Maggiore varietà di format",
      "Ideazione dei contenuti + script",
      "Organizzazione delle riprese",
      "Shooting professionale in 4K",
      "Luci, microfoni, gimbal e attrezzatura professionale",
      "Montaggio, sottotitoli, musiche e grafiche",
      "Ottimizzazione per Instagram, Facebook e TikTok",
      "Supporto continuativo",
      "Sponsorizzazioni mensili incluse",
    ],
  },
];

export const METHOD = [
  {
    n: "01",
    title: "Primo confronto",
    desc: "Fernando conosce l'attività, i servizi, i prodotti, il pubblico e gli obiettivi.",
  },
  {
    n: "02",
    title: "Strategia",
    desc: "Vengono studiati i format, le idee e la direzione della comunicazione.",
  },
  {
    n: "03",
    title: "Script e organizzazione",
    desc: "Vengono preparati i contenuti e pianificata la giornata di riprese.",
  },
  {
    n: "04",
    title: "Shooting",
    desc: "I video vengono registrati con una direzione semplice e naturale.",
  },
  {
    n: "05",
    title: "Montaggio",
    desc: "I contenuti vengono montati, sottotitolati e ottimizzati.",
  },
  {
    n: "06",
    title: "Promozione",
    desc: "Il budget pubblicitario già incluso viene utilizzato per sponsorizzare i contenuti selezionati.",
  },
];

export const CASE_STUDIES = [
  {
    sector: "Concessionaria",
    icon: "Car",
    rows: [
      "Situazione iniziale",
      "Obiettivo",
      "Strategia",
      "Format realizzati",
      "Esempi di video",
      "Risultati",
    ],
  },
  {
    sector: "Negozio",
    icon: "Store",
    rows: [
      "Prodotti da valorizzare",
      "Necessità di contenuti differenti",
      "Video educativi",
      "Video prodotto",
      "Sketch e storytelling",
      "Risultati",
    ],
  },
  {
    sector: "Servizi / Eventi",
    icon: "Sparkles",
    rows: [
      "Difficoltà nel mostrare il servizio",
      "Contenuti parlati",
      "Format informativi",
      "Video promozionali",
      "Costruzione della fiducia",
      "Risultati",
    ],
  },
];

export const FAQS = [
  {
    q: "Il prezzo comprende anche le sponsorizzazioni?",
    a: "Sì. Il 10% del valore del piano viene già destinato ogni mese alle sponsorizzazioni. Nel piano Fast 8 sono inclusi 49,90 € mensili, nel piano Fast 12 sono inclusi 69,90 € mensili.",
  },
  {
    q: "Ci sono costi aggiuntivi?",
    a: "No. Il prezzo indicato è il prezzo mensile completo e comprende i servizi previsti, le tasse e il budget pubblicitario incluso. Non ci sono costi nascosti.",
  },
  {
    q: "Qual è il prezzo reale del piano Fast 8?",
    a: "Il piano Fast 8 ha un prezzo previsto di 599 € al mese, ma viene proposto con 100 € di sconto a 499 € al mese.",
  },
  {
    q: "Qual è il prezzo reale del piano Fast 12?",
    a: "Il piano Fast 12 ha un prezzo previsto di 799 € al mese, ma viene proposto con 100 € di sconto a 699 € al mese.",
  },
  {
    q: "Dobbiamo trovare noi le idee?",
    a: "No. Fernando studia l'attività e sviluppa le idee, i format e gli script.",
  },
  {
    q: "Dobbiamo saper parlare davanti alla telecamera?",
    a: "No. Gli script vengono scritti in maniera naturale e durante le riprese il cliente viene guidato passo dopo passo.",
  },
  {
    q: "I video saranno tutti promozionali?",
    a: "No. La strategia può comprendere contenuti educativi, ironici, informativi, narrativi, promozionali e dedicati ai prodotti o servizi.",
  },
  {
    q: "I contenuti sono utilizzabili su più piattaforme?",
    a: "Sì. I video vengono ottimizzati principalmente per Instagram, Facebook e TikTok.",
  },
  {
    q: "Posso scegliere il piano in base alle mie esigenze?",
    a: "Sì. Il piano Fast 8 è adatto a chi vuole una presenza costante, mentre il piano Fast 12 permette di pubblicare più frequentemente e testare una maggiore varietà di contenuti.",
  },
];

export const SETTORI = [
  "Concessionaria",
  "Negozio",
  "Ristorante / Pizzeria",
  "Bar / Locale",
  "Eventi / Animazione",
  "Estetica / Benessere",
  "Professionista",
  "Struttura ricettiva",
  "Azienda locale / Brand",
  "Altro",
];

// Opzioni per il campo "Piano di interesse" del modulo di contatto
export const PLAN_OPTIONS = [
  { value: "Pacchetto Pro 8 — 499 € al mese", label: "Pacchetto Pro 8 — 499 € al mese" },
  { value: "Pacchetto Pro Max 12 — 699 € al mese", label: "Pacchetto Pro Max 12 — 699 € al mese" },
  { value: "Desidero una consulenza", label: "Desidero una consulenza" },
];
